import GoogleSheet from "@/assets/js/models/GoogleSheet/GoogleSheet";
import startCase from "lodash-es/startCase";

export default {
    filter: {
        search: {
            placeholder: 'Filter sheets by name'
        }
    },
    table: {
        name: 'Name',
        date: 'Creation Date',
        email: 'Email',
        status: 'Status',
        inserts_orders_form: 'Insert orders from',
        actions: 'Actions'
    },
    statuses: {
        [GoogleSheet.ACTIVE_STATUS]: startCase(GoogleSheet.ACTIVE_STATUS),
        [GoogleSheet.INACTIVE_STATUS]: startCase(GoogleSheet.INACTIVE_STATUS),
    },
    form: {
        important_alert: {
            important: 'Important',
            please_share: 'Please share (as Editor) your Google Sheet with',
            to_allow: 'to allow order updates.'
        },
        create: {
            title: 'Create Google Sheet Setup',
            button: 'Create Google Sheet Setup',
        },
        edit: {
            title: 'Edit Google Sheet Setup',
            button: 'Save Google Sheet Setup',
        },
        dialogs: {
            delete_sheet: {
                title: 'Delete Google Sheet',
                content: 'Are you sure you want to delete this Google Sheet?',
            }
        },
        buttons: {
            create: 'Create Setup',
            save: 'Save Setup',
            cancel: 'Cancel'
        },
        fields: {
            name: {
                title: 'Google sheet name',
                placeholder: 'MAXCOM Orders',
                hint: 'Give any name to your sheet setup'
            },
            status: {
                title: 'Status'
            },
            sheet_url: {
                title: 'Google sheet URL',
                placeholder: 'https://docs.google.com/spreadsheets/d/XXXXXXXXX...',
            },
            insert_orders_from: {
                title: 'Source of Orders',
                subTitle: 'From where do you want to get orders ?'
            },
            from_warehouses: {
                title: 'From Warehouse(s)',
            },
            from_anywhere: {
                title: 'From Anywhere',
            },
            from_stores: {
                title: 'From Store(s)',
            },
            from_sale_pages: {
                title: 'From Sale Page(s)',
            },
            from_products: {
                title: 'From Product(s)',
            },
            order_columns: {
                title: 'Order info',
                subTitle: 'You can change columns order, and you can enable/disable as you want.',
                order_id: 'Order Id',
                order_date: 'Order Date',
                customer_name: 'Customer Name',
                phone_number: 'Phone Number',
                shipping_address: 'Shipping Address',
                customer_country: 'Customer Country',
                customer_country_code: 'Customer Country Code',
                city: 'City',
                custom_city: 'Custom city',
                region: 'Region',
                custom_region: 'Custom region',
                postal_code: 'Postal code',
                product_name: 'Product Name',
                offer_name: 'Offer Name',
                product_sku: 'Product sku',
                quantity: 'Quantity',
                unit_price: 'Unit Price',
                total_price: 'Total price',
                payment_method: 'Payment Method',
                currency: 'Currency',
            }
        }
    }
}